var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
/**
 * Fetches all IIM runs for a specific inspection
 * @param inspectionId - The ID of the inspection
 * @returns Promise resolving to an array of IIMRun objects
 */
export function getRunsForInspection(inspectionId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const url = `/api/internal/iim_runs?inspection_id=${inspectionId}&select[all]=true`;
            const response = yield api.get(url);
            return response.data.data;
        }
        catch (error) {
            console.error('Error getting IIM runs:', error);
            throw error;
        }
    });
}
/**
 * Fetches activities for specific IIM runs
 * @param runIds - Array of run IDs to fetch activities for
 * @returns Promise resolving to an array of IIMRunActivity objects
 */
export function getRunActivities(runIds) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            if (!runIds.length) {
                return [];
            }
            // Construct URL with multiple run_id[] parameters
            const runIdParams = runIds.map((id) => `run_id[]=${id}`).join('&');
            const url = `/api/internal/iim_run_activities?${runIdParams}`;
            const response = (yield api.get(url));
            return response.data;
        }
        catch (error) {
            console.error('Error getting IIM run activities:', error);
            throw error;
        }
    });
}
/**
 * Fetches both runs and their activities for an inspection and combines them
 * @param inspectionId - The ID of the inspection
 * @returns Promise resolving to an array of IIMRunWithActivities objects
 */
export function getRunsWithActivities(inspectionId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            // Get all runs for the inspection
            const runs = yield getRunsForInspection(inspectionId);
            if (!runs.length) {
                return [];
            }
            // Get activities for all runs
            const runIds = runs.map((run) => run.id);
            const activities = yield getRunActivities(runIds);
            // Combine runs with their activities
            return runs.map((run) => {
                const runActivity = activities.find((activity) => activity.runId === run.id);
                return Object.assign(Object.assign({}, run), { activities: runActivity || {
                        runId: run.id,
                        runStatus: run.status,
                        triggeredAt: run.startedAt,
                        completedAt: run.endedAt,
                        subprocesses: []
                    } });
            });
        }
        catch (error) {
            console.error('Error getting IIM runs with activities:', error);
            throw error;
        }
    });
}
